"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectApi = void 0;
exports.createProjectApi = (axios) => ({
    listProjects() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/projects')).data;
        });
    },
    getProjectById(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/project/${props.projectId}`)).data;
        });
    },
    createProject(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post('/projects', props)).data;
        });
    },
    updateProject(_a) {
        var { projectId } = _a, rest = __rest(_a, ["projectId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/project/${projectId}`, rest)).data;
        });
    },
    deleteProject(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/project/${props.projectId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdEFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvcHJvamVjdEFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsZ0JBQWdCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ25ELFlBQVk7O1lBQ2hCLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDN0MsQ0FBQztLQUFBO0lBRUssY0FBYyxDQUFDLEtBRXBCOztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxLQUFLLENBQUMsU0FBUyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUMvRCxDQUFDO0tBQUE7SUFFSyxhQUFhLENBQUMsS0FpQm5COztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ3JELENBQUM7S0FBQTtJQUVLLGFBQWEsQ0FBQyxFQXNCbkI7WUF0Qm1CLEVBQ2xCLFNBQVMsT0FxQlYsRUFwQkksSUFBSSxjQUZXLGFBR25CLENBRFE7O1lBcUJQLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxTQUFTLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQzs7S0FDOUQ7SUFFSyxhQUFhLENBQUMsS0FBNEI7O1lBQzlDLE1BQU0sS0FBSyxDQUFDLE1BQU0sQ0FBQyxZQUFZLEtBQUssQ0FBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDO1FBQ3BELENBQUM7S0FBQTtDQUNGLENBQUMsQ0FBQyJ9